<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12 d-flex align-middle">
      <div
        class="page-title-box d-flex align-items-center justify-content-between"
      >
        <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>

        <div class="page-title-right" hidden>
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    testObject: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
